import { render, staticRenderFns } from "./notification-card.vue?vue&type=template&id=bd53e274&scoped=true&"
import script from "./notification-card.vue?vue&type=script&lang=js&"
export * from "./notification-card.vue?vue&type=script&lang=js&"
import style0 from "./notification-card.vue?vue&type=style&index=0&lang=css&"
import style1 from "./notification-card.vue?vue&type=style&index=1&id=bd53e274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd53e274",
  null
  
)

export default component.exports
import {QCard,QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QIcon})
